import { Link } from 'react-router-dom';
import Container from '../../components/ui/Container';

export default function NotFound() {
  return (
    <Container narrow>
      <div style={{ textAlign: 'center', padding: 'var(--space-7) 0' }}>
        <h1>Página no encontrada</h1>
        <p style={{ color: 'var(--c-text-muted)' }}>
          La dirección a la que intentaste acceder no existe.
        </p>
        <Link to="/">← Volver al inicio</Link>
      </div>
    </Container>
  );
}
